import { CAvatar, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { CButton, CFormTextarea } from '@coreui/react'
// const HierarchyComponent = ({ viewData, splitTitle = false, isNormalOrModal = false }) => {
//     const [hierarchy, setHierarchy] = useState(viewData?.hierarchy || []);

//     const toggleIsSelected = (id, items) => {

//         return items.map((item) => {

//             if (item.id === id) {
//                 return { ...item, isSelected: !item.isSelected };
//             }

//             if (item.hierarchy?.length > 0) {
//                 return {
//                     ...item,
//                     hierarchy: toggleIsSelected(
//                         id,
//                         item.hierarchy,
//                     ),
//                 };
//             }
//             return item;
//         });

//     };

//     const handleInputChange = (id, value) => {
//         const updateInputData = (items) => {
//             return items.map((item) => {
//                 if (item.id === id) {
//                     return { ...item, inputData: value };
//                 }
//                 if (item.hierarchy?.length > 0) {
//                     return { ...item, hierarchy: updateInputData(item.hierarchy) };
//                 }
//                 return item;
//             });
//         };
//         setHierarchy(updateInputData(hierarchy));
//     };
//     const [alertIds, setAlertIds] = useState([])
//     const [educationFiles, setEducationFiles] = useState([])

//     const renderHierarchy = (items = [], rowAlign = false, hierarchyType) => {
//         return (
//             <>
//                 {/* {hierarchyType === 'single' ? "d-flex align-items-start flex-wrap gap-1" :  */}
//                 <div className={`timelines-container  ${rowAlign ? "d-flex align-items-start" : ""}`}>
//                     <div className="timelines-line"></div>
//                     {items.map((item, idx) => (
//                         <div
//                             key={idx}
//                             className={`timelines-item my-1 ${rowAlign ? "" : ""}`}
//                             style={{ marginLeft: "20px" }}
//                         >
//                             <div className="d-flex align-items-center gap-2">
//                                 <CButton
//                                     className='my-1'
//                                     size="sm"
//                                     // color={item.isSelected ? "success" : "secondary"}header - #414A59
//                                     onClick={() => {
//                                         const updatedHierarchy = toggleIsSelected(item.id, hierarchy);
//                                         setHierarchy(updatedHierarchy);
//                                     }}
//                                     style={{
//                                         borderRadius: "10px",
//                                         alignSelf: "flex-start",
//                                         cursor: "pointer",
//                                         backgroundColor: item.isSelected && item.type && item.type === 'header' ? "#414a59a8" : item.isSelected && item.type && item.type === 'option' ? "#6EC66E" : "white",
//                                         border: item.isSelected && item.type && item.type === 'header' ? "0px solid #828891" : item.isSelected && item.type === 'option' ? "0px solid #828891" : "1px solid #828891",
//                                         color: item.isSelected && item.type && item.type === 'header' ? "" : item.isSelected && item.type === 'option' ? "white" : "black",
//                                     }}
//                                 >
//                                     {splitTitle ? item.name.split("-")[0] : item.name}
//                                 </CButton>
//                                 <div className="d-flex align-items-start  gap-1">
//                                     <div className="d-flex align-items-start  gap-1">
//                                         <CButton
//                                             onClick={() => {
//                                                 if (item.education.length === 0 || !item.education) return
//                                                 setEducationFiles(item.education)
//                                             }}
//                                             className="rounded-pill p-0 d-flex align-items-center justify-content-center " style={{ width: "20px", height: "20px", fontSize: "10px" }} color="secondary" variant="outline">e</CButton>
//                                     </div>
//                                     <div className="d-flex align-items-center  gap-1">
//                                         <CButton
//                                             onClick={() => {
//                                                 if (alertIds.includes(item.id)) {
//                                                     setAlertIds(alertIds.filter(id => id !== item.id))
//                                                 }
//                                                 else {
//                                                     setAlertIds([...alertIds, item.id])
//                                                 }
//                                             }}
//                                             className="rounded-pill p-0 d-flex align-items-center justify-content-center " style={{ width: "20px", height: "20px", fontSize: "12px" }} color="secondary" variant="outline">i</CButton>
//                                         {
//                                             alertIds.includes(item.id) && <p style={{ fontSize: "10px" }} className="p-0 text-warning m-0">{item.alert}</p>
//                                         }
//                                     </div>
//                                 </div>
//                             </div>
//                             {item.isSelected && item.hierarchyType === "input" && (
//                                 <CFormTextarea
//                                     rows={3}
//                                     type="text"
//                                     value={item.inputData || ""}
//                                     onChange={(e) => handleInputChange(item.id, e.target.value)}
//                                     placeholder="Enter value"
//                                     className="form-control mt-2 w-100"
//                                 />
//                             )}
//                             {item.isSelected && item.hierarchy?.length > 0 &&
//                                 renderHierarchy(item.hierarchy, item.rowAlign, item.hierarchyType)}
//                         </div>
//                     ))}
//                 </div>
//                 <CModal
//                     alignment="center"
//                     scrollable
//                     backdrop="static"
//                     visible={educationFiles.length > 0}
//                     onClose={() => setEducationFiles([])}
//                     aria-labelledby="VerticallyCenteredScrollableExample2"
//                 >
//                     <CModalHeader>
//                         <CModalTitle id="VerticallyCenteredScrollableExample2">Educations Files</CModalTitle>
//                     </CModalHeader>
//                     <CModalBody>
//                         <div>
//                             {educationFiles.map((edu, idx) => {
//                                 return (
//                                     <div
//                                         key={idx}
//                                         style={{
//                                             width: "100px",
//                                             overflow: "hidden",
//                                             height: "100px",
//                                             backgroundColor: "gray",
//                                             borderRadius: "3%",
//                                             display: "flex",
//                                             alignItems: "center",
//                                             justifyContent: "center",
//                                         }}
//                                     >
//                                         {edu.type === "image" && (
//                                             <img
//                                                 className="object-fit-cover w-100 h-100"
//                                                 src={edu.url}
//                                                 alt="Education File"
//                                                 onError={(e) => {
//                                                     e.target.onerror = null;
//                                                     e.target.src = "fallback-image-url";
//                                                 }}
//                                             />
//                                         )}

//                                         {edu.type === "video" && (
//                                             <video
//                                                 className="object-fit-cover w-100 h-100"
//                                                 controls
//                                                 src={edu.url}
//                                                 alt="Education Video"
//                                             />
//                                         )}

//                                         {edu.type === "pdf" && (
//                                             <a
//                                                 href={edu.url}
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                                 className="text-white text-center"
//                                                 style={{ fontSize: "12px" }}
//                                             >
//                                                 View PDF
//                                             </a>
//                                         )}

//                                         {edu.type === "file" && (
//                                             <a
//                                                 href={edu.url}
//                                                 download
//                                                 className="text-white text-center"
//                                                 style={{ fontSize: "12px" }}
//                                             >
//                                                 Download File
//                                             </a>
//                                         )}
//                                     </div>
//                                 )
//                             })}
//                         </div>
//                     </CModalBody>
//                     <hr />
//                     <CModalFooter>
//                         <CButton variant='outline' color="secondary" onClick={() => setEducationFiles([])}>
//                             Close
//                         </CButton>
//                     </CModalFooter>
//                 </CModal>
//             </>
//         );
//     };
//     return (
//         <>
//             {
//                 isNormalOrModal ? (
//                     <div style={{ height: "70vh", overflowY: "auto" }}>
//                         {renderHierarchy(hierarchy)}
//                     </div>)
//                     :
//                     <CModalBody style={{ height: "70vh", overflowY: "auto" }}>
//                         {renderHierarchy(hierarchy)}
//                     </CModalBody>
//             }
//         </>

//     );
// };
// export default HierarchyComponent;
import React, { useState } from 'react'
import PENoteView from '../../components/shared/PENoteView'

const HierarchyComponents = ({ viewData, splitTitle = false, isNormalOrModal = false }) => {
  const [hierarchy, setHierarchy] = useState([{ ...viewData }])
  const [alertIds, setAlertIds] = useState([])
  const [educationFiles, setEducationFiles] = useState([])

  const handleInputChange = (id, value) => {
    const updateInputData = (items) => {
      return items.map((item) => {
        if (item.id === id) {
          return { ...item, inputData: value }
        }
        if (item.hierarchy?.length > 0) {
          return { ...item, hierarchy: updateInputData(item.hierarchy) }
        }
        return item
      })
    }
    setHierarchy(updateInputData(hierarchy))
  }

  // const toggleIsSelected = (id, items) => {
  //   return items.map((item) => {
  //     if (item.id === id) {
  //       return { ...item, isSelected: !item.isSelected }
  //     }

  //     if (item.hierarchy?.length) {
  //       let updatedHierarchy = toggleIsSelected(id, item.hierarchy)

  //       // Check if the direct parent has `hierarchyType: "single"`
  //       if (updatedHierarchy.some((child) => child.id === id) && item.hierarchyType === 'single') {
  //         updatedHierarchy = updatedHierarchy.map((child) => ({
  //           ...child,
  //           isSelected: child.id === id, // Keep only the selected child `true`, others `false`
  //         }))
  //       }

  //       return {
  //         ...item,
  //         hierarchy: updatedHierarchy,
  //       }
  //     }

  //     return item
  //   })
  // }

  const toggleIsSelected = (id, items) => {
    return items.map((item) => {
      if (item.id === id) {
        return { ...item, isSelected: !item.isSelected }
      }

      if (item.hierarchy?.length) {
        let updatedHierarchy = toggleIsSelected(id, item.hierarchy)

        const clickedChild = updatedHierarchy.find((child) => child.id === id)

        if (clickedChild && item.hierarchyType === 'single' && !['header', 'subHeader'].includes(clickedChild.type)) {
          updatedHierarchy = updatedHierarchy.map((child) => ({
            ...child,
            isSelected: child.id === id,
          }))
        }

        return {
          ...item,
          hierarchy: updatedHierarchy,
        }
      }

      return item
    })
  }

  const handleToggle = (id) => {
    setHierarchy((prevHierarchy) => toggleIsSelected(id, prevHierarchy))
  }

  const handleAlertToggle = (id) => {
    setAlertIds((prev) => (prev.includes(id) ? prev.filter((alertId) => alertId !== id) : [...prev, id]))
  }

  const renderHierarchy = (items = [], rowAlign = false) => (
    <>
      <div className={`timelines-container ${rowAlign ? 'd-flex align-items-start flex-wrap' : ''}`}>
        <div className="timelines-line"></div>
        {items.map((item) => (
          <div key={item.id} className="timelines-item my-1" style={{ marginLeft: '20px' }}>
            <div className="d-flex align-items-center gap-2">
              <CButton
                className="my-1"
                size="sm"
                color={item.isSelected ? 'success' : 'secondary'}
                onClick={() => handleToggle(item.id)}
                style={{
                  borderRadius: '10px',
                  alignSelf: 'flex-start',
                  cursor: 'pointer',
                  backgroundColor: (item.isSelected && item.type && item.type === 'header') || (item.isSelected && item.type && item.type === 'subHeader') ? '#414a59a8' : item.isSelected && item.type && item.type === 'option' ? '#6EC66E' : 'white',
                  border: (item.isSelected && item.type && item.type === 'header') || (item.isSelected && item.type && item.type === 'subHeader') ? '0px solid #828891' : item.isSelected && item.type === 'option' ? '0px solid #828891' : '1px solid #828891',
                  color: (item.isSelected && item.type && item.type === 'header') || (item.isSelected && item.type && item.type === 'subHeader') ? 'white' : item.isSelected && item.type === 'option' ? 'white' : 'black',
                }}
              >
                {splitTitle ? item.name.split('-')[0] : item.name}
              </CButton>

              {/* Education Files Button */}
              {item?.education?.length > 0 && (
                <div className="d-flex align-items-start  gap-1">
                  <CButton
                    onClick={() => {
                      if (item.education.length === 0 || !item.education) return
                      setEducationFiles(item.education)
                    }}
                    className="rounded-pill p-0 d-flex align-items-center justify-content-center "
                    style={{ width: '20px', height: '20px', fontSize: '10px' }}
                    color="secondary"
                    variant="outline"
                  >
                    e
                  </CButton>
                </div>
              )}

              {/* Alert Toggle Button */}
              {item?.alert !== '' && (
                <CButton onClick={() => handleAlertToggle(item.id)} className="rounded-pill p-0 d-flex align-items-center justify-content-center" style={{ width: '20px', height: '20px', fontSize: '12px' }} color="secondary" variant="outline">
                  i
                </CButton>
              )}
              {alertIds.includes(item.id) && (
                <p className="p-0 text-warning m-0" style={{ fontSize: '10px' }}>
                  {item.alert}
                </p>
              )}
            </div>

            {/* Input Field for Selected Hierarchy */}
            {item.isSelected && item.hierarchyType === 'input' && <CFormTextarea rows={3} type="text" value={item.inputData || ''} onChange={(e) => handleInputChange(item.id, e.target.value)} placeholder="Enter value" className="form-control mt-2 w-100" />}

            {/* Render Child Hierarchy */}
            {item.isSelected && item.hierarchy?.length > 0 && renderHierarchy(item.hierarchy, item.rowAlign)}
          </div>
        ))}
      </div>

      <CModal alignment="center" scrollable backdrop="static" visible={educationFiles.length > 0} onClose={() => setEducationFiles([])}>
        <CModalHeader>
          <CModalTitle>Education Files</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="d-flex flex-wrap gap-2">
            {educationFiles.map((edu, idx) => (
              <div
                key={idx}
                style={{
                  width: '100px',
                  height: '100px',
                  backgroundColor: 'gray',
                  borderRadius: '3%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {edu.type === 'image' && <img className="w-100 h-100 object-fit-cover" src={edu.url} alt="Education File" onError={(e) => (e.target.src = 'fallback-image-url')} />}
                {edu.type === 'video' && <video className="w-100 h-100 object-fit-cover" controls src={edu.url} />}
                {edu.type === 'pdf' && (
                  <a href={edu.url} target="_blank" rel="noopener noreferrer" className="text-white text-center" style={{ fontSize: '12px' }}>
                    View PDF
                  </a>
                )}
                {edu.type === 'file' && (
                  <a href={edu.url} download className="text-white text-center" style={{ fontSize: '12px' }}>
                    Download File
                  </a>
                )}
              </div>
            ))}
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setEducationFiles([])}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className=" " style={{ width: '60%', height: '70vh', overflow: 'auto' }}>
          <div style={{ width: '4000px' }}>{isNormalOrModal ? <div className=" ">{renderHierarchy(hierarchy)}</div> : <div className=" ">{renderHierarchy(hierarchy)}</div>}</div>
        </div>

        <div style={{ width: '40%', height: '70vh' }}>
          <PENoteView data={hierarchy} />
        </div>
      </div>
    </>
  )
}

export default HierarchyComponents
// ```javascript
// import { CAvatar, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
// import { CButton, CFormTextarea, } from "@coreui/react";
// import React, { useState } from 'react';
// import PENoteView from '../../components/shared/PENoteView';

// const HierarchyComponents = ({ viewData, splitTitle = false, isNormalOrModal = false }) => {

//     const [hierarchy, setHierarchy] = useState([{ ...viewData }]);
//     const [alertIds, setAlertIds] = useState([]);
//     const [educationFiles, setEducationFiles] = useState([]);

//     const handleInputChange = (id, value) => {
//         const updateInputData = (items) => {
//             return items.map((item) => {
//                 if (item.id === id) {
//                     return { ...item, inputData: value };
//                 }
//                 if (item.hierarchy?.length > 0) {
//                     return { ...item, hierarchy: updateInputData(item.hierarchy) };
//                 }
//                 return item;
//             });
//         };
//         setHierarchy(updateInputData(hierarchy));
//     };

//     const toggleIsSelected = (id, items) => {
//         return items.map(item => {
//             if (item.id === id) {
//                 return { ...item, isSelected: !item.isSelected };
//             }

//             if (item.hierarchy?.length) {
//                 let updatedHierarchy = toggleIsSelected(id, item.hierarchy);

//                 // Check if the direct parent has `hierarchyType: "single"`
//                 if (updatedHierarchy.some(child => child.id === id) && item.hierarchyType === "single") {
//                     updatedHierarchy = updatedHierarchy.map(child => ({
//                         ...child,
//                         isSelected: child.id === id // Keep only the selected child `true`, others `false`
//                     }));
//                 }

//                 return {
//                     ...item,
//                     hierarchy: updatedHierarchy
//                 };
//             }

//             return item;
//         });
//     };

//     const handleToggle = (id) => {
//         setHierarchy(prevHierarchy => toggleIsSelected(id, prevHierarchy));
//     };

//     const handleAlertToggle = (id) => {
//         setAlertIds(prev => prev.includes(id) ? prev.filter(alertId => alertId !== id) : [...prev, id]);
//     };

//     const renderHierarchy = (items = [], rowAlign = false) => (
//         <>
//             <div className={`timelines-container ${rowAlign ? "d-flex align-items-start flex-wrap" : ""}`}>
//                 <div className="timelines-line"></div>
//                 {items.map(item => (
//                     <div key={item.id} className="timelines-item my-1" style={{ marginLeft: "20px" }}>
//                         <div className="d-flex align-items-center gap-2">
//                             <CButton
//                                 className='my-1'
//                                 size="sm"
//                                 color={item.isSelected ? "success" : "secondary"}
//                                 onClick={() => handleToggle(item.id)}
//                                 style={{
//                                     borderRadius: "10px",
//                                     alignSelf: "flex-start",
//                                     cursor: "pointer",
//                                     backgroundColor: item.isSelected && item.type && item.type === 'header' || item.isSelected && item.type && item.type === 'subHeader' ? "#414a59a8" : item.isSelected && item.type && item.type === 'option' ? "#6EC66E" : "white",
//                                     border: item.isSelected && item.type && item.type === 'header' || item.isSelected && item.type && item.type === 'subHeader' ? "0px solid #828891" : item.isSelected && item.type === 'option' ? "0px solid #828891" : "1px solid #828891",
//                                     color: item.isSelected && item.type && item.type === 'header' || item.isSelected && item.type && item.type === 'subHeader' ? "white" : item.isSelected && item.type === 'option' ? "white" : "black",
//                                 }}
//                             >
//                                 {splitTitle ? item.name.split("-")[0] : item.name}
//                             </CButton>

//                             {/* Education Files Button */}
//                             <div className="d-flex align-items-start  gap-1">
//                                 <CButton
//                                     onClick={() => {
//                                         if (item.education.length === 0 || !item.education) return
//                                         setEducationFiles(item.education)
//                                     }}
//                                     className="rounded-pill p-0 d-flex align-items-center justify-content-center " style={{ width: "20px", height: "20px", fontSize: "10px" }} color="secondary" variant="outline">e</CButton>
//                             </div>

//                             {/* Alert Toggle Button */}
//                             <CButton
//                                 onClick={() => handleAlertToggle(item.id)}
//                                 className="rounded-pill p-0 d-flex align-items-center justify-content-center"
//                                 style={{ width: "20px", height: "20px", fontSize: "12px" }}
//                                 color="secondary"
//                                 variant="outline"
//                             >
//                                 i
//                             </CButton>
//                             {alertIds.includes(item.id) && <p className="p-0 text-warning m-0" style={{ fontSize: "10px" }}>{item.alert}</p>}
//                         </div>

//                         {/* Input Field for Selected Hierarchy */}
//                         {item.isSelected && item.hierarchyType === "input" && (
//                             <CFormTextarea
//                                 rows={3}
//                                 type="text"
//                                 value={item.inputData || ""}
//                                 onChange={(e) => handleInputChange(item.id, e.target.value)}
//                                 placeholder="Enter value"
//                                 className="form-control mt-2 w-100"
//                             />
//                         )}

//                         {/* Render Child Hierarchy */}
//                         {item.isSelected && item.hierarchy?.length > 0 && renderHierarchy(item.hierarchy, item.rowAlign)}
//                     </div>
//                 ))}
//             </div>

//             <CModal alignment="center" scrollable backdrop="static" visible={educationFiles.length > 0} onClose={() => setEducationFiles([])}>
//                 <CModalHeader>
//                     <CModalTitle>Education Files</CModalTitle>
//                 </CModalHeader>
//                 <CModalBody>
//                     <div className="d-flex flex-wrap gap-2">
//                         {educationFiles.map((edu, idx) => (
//                             <div key={idx} style={{
//                                 width: "100px", height: "100px", backgroundColor: "gray",
//                                 borderRadius: "3%", display: "flex", alignItems: "center", justifyContent: "center",
//                             }}>
//                                 {edu.type === "image" && <img className="w-100 h-100 object-fit-cover" src={edu.url} alt="Education File" onError={(e) => e.target.src = "fallback-image-url"} />}
//                                 {edu.type === "video" && <video className="w-100 h-100 object-fit-cover" controls src={edu.url} />}
//                                 {edu.type === "pdf" && <a href={edu.url} target="_blank" rel="noopener noreferrer" className="text-white text-center" style={{ fontSize: "12px" }}>View PDF</a>}
//                                 {edu.type === "file" && <a href={edu.url} download className="text-white text-center" style={{ fontSize: "12px" }}>Download File</a>}
//                             </div>
//                         ))}
//                     </div>
//                 </CModalBody>
//                 <CModalFooter>
//                     <CButton variant='outline' color="secondary" onClick={() => setEducationFiles([])}>Close</CButton>
//                 </CModalFooter>
//             </CModal>
//         </>
//     );

//     return (
//         <>
//             <div className='d-flex justify-content-between'>
//                 <div className=" w-75">
//                     {
//                         isNormalOrModal ? (
//                             <div style={{ height: "70vh", overflowY: "auto" }}>
//                                 {renderHierarchy(hierarchy)}
//                             </div>)
//                             :
//                             <CModalBody style={{ height: "70vh", overflow: "auto" }}>
//                                 {renderHierarchy(hierarchy)}
//                             </CModalBody>
//                     }
//                 </div>
//                 <div className=' w-25' style={{ height: "70vh" }} >
//                     <PENoteView data={hierarchy} />
//                 </div>
//             </div>
//         </>
//     );
// };

// export default HierarchyComponents;
// ```
